<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>

<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened" *ngIf="!loading">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='@@customerOverviewComponent.heading.sepaMandates' class="esf-action-heading__text">SEPA Mandates</span>
    </h1>

    <table class="esf-table"
           *ngIf="sepaMandates?.length"
           app-table
           [columns]="columns"
           [keys]="keys"
           [data]="sepaMandates">
    </table>

  </div>
</main>